export default function UserManual() {
  return (
    <div className="usermanual-page">
      <style>{`
        .usermanual-page {
          --navy: #070d51;
          --navy-light: #131b6b;
          --cyan: #00b4f7;
          --ink: #1e2333;
          --muted: #64748b;
          --border: #e2e8f0;
          --bg: #f7f8fc;
          font-family: -apple-system, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
          background: var(--bg);
          color: var(--ink);
          line-height: 1.6;
        }
        .usermanual-page * { box-sizing: border-box; }
        .usermanual-page .hero {
          background: var(--navy);
          color: #fff;
          padding: 64px 24px 56px;
          text-align: center;
        }
        .usermanual-page .hero .eyebrow {
          font-size: 12px;
          font-weight: 800;
          letter-spacing: 0.3em;
          text-transform: uppercase;
          color: var(--cyan);
        }
        .usermanual-page .hero h1 {
          font-size: 40px;
          font-weight: 900;
          text-transform: uppercase;
          letter-spacing: -0.02em;
          margin: 12px 0 8px;
        }
        .usermanual-page .hero p {
          color: #cbd3f0;
          max-width: 560px;
          margin: 0 auto;
          font-size: 15px;
        }
        .usermanual-page .wrap {
          max-width: 900px;
          margin: 0 auto;
          padding: 0 24px 80px;
        }
        .usermanual-page .toc {
          background: #fff;
          border: 1px solid var(--border);
          border-radius: 10px;
          padding: 24px 28px;
          margin-top: -32px;
          box-shadow: 0 10px 30px rgba(7,13,81,0.08);
        }
        .usermanual-page .toc h2 { font-size: 13px; text-transform: uppercase; letter-spacing: 0.15em; color: var(--navy); margin: 0 0 12px; }
        .usermanual-page .toc ol { margin: 0; padding-left: 20px; columns: 2; column-gap: 32px; }
        .usermanual-page .toc li { margin-bottom: 8px; font-size: 14px; }
        .usermanual-page .toc a { color: var(--navy-light); text-decoration: none; font-weight: 600; }
        .usermanual-page .toc a:hover { color: var(--cyan); }
        .usermanual-page section.step {
          background: #fff;
          border: 1px solid var(--border);
          border-radius: 10px;
          margin-top: 32px;
          padding: 32px;
          scroll-margin-top: 20px;
        }
        .usermanual-page .step-number {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 34px;
          height: 34px;
          border-radius: 999px;
          background: var(--navy);
          color: #fff;
          font-weight: 800;
          font-size: 15px;
          margin-right: 12px;
          flex-shrink: 0;
        }
        .usermanual-page .step-title {
          display: flex;
          align-items: center;
          margin-bottom: 6px;
        }
        .usermanual-page .step-title h2 {
          font-size: 20px;
          font-weight: 800;
          text-transform: uppercase;
          letter-spacing: -0.01em;
          color: var(--navy);
          margin: 0;
        }
        .usermanual-page .step-sub { color: var(--muted); font-size: 14px; margin: 0 0 20px 46px; }
        .usermanual-page .step-body { margin-left: 46px; }
        .usermanual-page .step-body p { font-size: 15px; }
        .usermanual-page .step-body ul, .usermanual-page .step-body ol { font-size: 15px; padding-left: 22px; }
        .usermanual-page .step-body li { margin-bottom: 6px; }
        .usermanual-page .callout {
          background: #eef6ff;
          border-left: 3px solid var(--cyan);
          padding: 12px 16px;
          border-radius: 6px;
          font-size: 14px;
          margin: 14px 0;
        }
        .usermanual-page .callout.warn {
          background: #fff8ec;
          border-left-color: #f59e0b;
        }
        .usermanual-page .callout strong { color: var(--navy); }
        .usermanual-page code {
          background: #eef1fb;
          color: var(--navy);
          padding: 2px 6px;
          border-radius: 4px;
          font-size: 13px;
          font-family: "SF Mono", Menlo, Consolas, monospace;
        }
        .usermanual-page .cred-table {
          width: 100%;
          border-collapse: collapse;
          margin: 14px 0;
          font-size: 14px;
        }
        .usermanual-page .cred-table th, .usermanual-page .cred-table td {
          border: 1px solid var(--border);
          padding: 10px 12px;
          text-align: left;
        }
        .usermanual-page .cred-table th { background: var(--navy); color: #fff; font-size: 12px; text-transform: uppercase; letter-spacing: 0.05em; }
        .usermanual-page .cred-table td code { background: #f1f5f9; }
        .usermanual-page figure {
          margin: 20px 0 8px;
          border: 1px solid var(--border);
          border-radius: 8px;
          overflow: hidden;
          box-shadow: 0 6px 18px rgba(7,13,81,0.08);
        }
        .usermanual-page figure img { width: 100%; display: block; }
        .usermanual-page figcaption {
          padding: 10px 14px;
          font-size: 12px;
          color: var(--muted);
          background: #fafbfe;
          border-top: 1px solid var(--border);
        }
        .usermanual-page .two-col { display: grid; grid-template-columns: 1fr 1fr; gap: 20px; }
        @media (max-width: 720px) {
          .usermanual-page .two-col { grid-template-columns: 1fr; }
          .usermanual-page .toc ol { columns: 1; }
          .usermanual-page .step-body, .usermanual-page .step-sub { margin-left: 0; }
          .usermanual-page section.step { padding: 24px 18px; }
        }
        .usermanual-page .badge-pill {
          display: inline-block;
          font-size: 11px;
          font-weight: 800;
          text-transform: uppercase;
          letter-spacing: 0.08em;
          padding: 3px 10px;
          border-radius: 999px;
          background: rgba(0,180,247,0.12);
          color: var(--navy);
          margin-left: 8px;
        }
        .usermanual-page footer {
          text-align: center;
          padding: 40px 24px 60px;
          color: var(--muted);
          font-size: 13px;
        }
        .usermanual-page .backtotop {
          display: inline-block;
          margin-top: 20px;
          font-size: 12px;
          color: var(--cyan);
          text-decoration: none;
          font-weight: 700;
          text-transform: uppercase;
          letter-spacing: 0.08em;
        }
      `}</style>

      <div className="hero">
        <div className="eyebrow">Radish Technologies · Factory Visitor Hub</div>
        <h1>Admin &amp; HR Playbook</h1>
        <p>A step-by-step guide to setting up plants, badges, users, and gate kiosks — and running day-to-day check-ins and check-outs.</p>
      </div>

      <div className="wrap">
        <nav className="toc" id="top">
          <h2>On This Page</h2>
          <ol>
            <li><a href="#step1">Log in as Admin</a></li>
            <li><a href="#step2">Add Plants / Locations</a></li>
            <li><a href="#step3">Add Badge Numbers per Plant</a></li>
            <li><a href="#step4">Get Employees / Hosts Onboarded</a></li>
            <li><a href="#step5">Set Up a Gate Kiosk Device</a></li>
            <li><a href="#step6">Pre-Register vs Walk-In</a></li>
            <li><a href="#step7">Checking Visitors Out</a></li>
          </ol>
        </nav>

        <section className="step" id="step1">
          <div className="step-title"><span className="step-number">1</span><h2>Log In as Admin</h2></div>
          <p className="step-sub">Access the dashboard for the first time</p>
          <div className="step-body">
            <p>Open the app URL in a browser (desktop recommended for admin work). On the Sign In screen, ignore the <strong>"Sign in with Microsoft"</strong> button — that's for Employees/Hosts only. Scroll to the <strong>"Gate / Demo Login"</strong> section and sign in with the Admin account below.</p>
            <table className="cred-table">
              <tr><th>Role</th><th>Email</th><th>Password</th></tr>
              <tr><td>Admin</td><td><code>admin@factoryhub.com</code></td><td><code>Admin@123</code></td></tr>
            </table>
            <div className="callout warn">
              <strong>Security note:</strong> This is a shared default credential seeded when the app first launches. Please keep it confidential and share it only with the 1–2 people who will manage the system. There's currently no self-service "change password" screen — if you'd like this credential rotated or a personal Admin account created instead, just ask your Emergent agent to add it.
            </div>
            <figure>
              <img src="/playbook-assets/shot-login.jpg" alt="Sign in screen" />
              <figcaption>Sign In screen — Microsoft SSO up top (Employees/Hosts), Admin/Security password login below.</figcaption>
            </figure>
          </div>
        </section>

        <section className="step" id="step2">
          <div className="step-title"><span className="step-number">2</span><h2>Add Plants / Locations</h2></div>
          <p className="step-sub">Go to Settings → Gates / Locations</p>
          <div className="step-body">
            <p>In this app, each factory site is added as a <strong>"Gate"</strong> — this doubles as your list of Plants. Use full, unambiguous names since this exact name is what Employees and Security staff will see everywhere (onboarding, invite forms, kiosk):</p>
            <div className="callout">
              <strong>Naming convention:</strong> <code>Plant 1, Aligarh</code>, <code>Plant 2, Faridabad</code> … <code>Plant 9, Greater Noida</code>. Add one entry per physical site.
            </div>
            <ol>
              <li>From the sidebar, click <strong>Settings</strong>.</li>
              <li>Under <strong>Gates / Locations</strong>, type the full plant name into the input box.</li>
              <li>Click <strong>Add</strong>. It appears instantly in the list below and becomes available everywhere else in the app (Users, Pre-Register, Kiosk).</li>
              <li>Repeat for every plant. To remove one later, click the trash icon next to it (only do this if no active badges/visits reference it).</li>
            </ol>
            <figure>
              <img src="/playbook-assets/shot-settings.jpg" alt="Settings page — Gates / Locations and Visit Purposes" />
              <figcaption>Settings → Gates / Locations (left) and Visit Purposes (right). "Visit Purposes" is a separate, optional list for dropdown reasons like "Business Meeting" or "Delivery".</figcaption>
            </figure>
          </div>
        </section>

        <section className="step" id="step3">
          <div className="step-title"><span className="step-number">3</span><h2>Add Badge Numbers per Plant</h2></div>
          <p className="step-sub">Still on the Settings page — scroll to Badge Inventory</p>
          <div className="step-body">
            <p>Physical visitor badges are tracked per plant so the Kiosk always knows what's available. A badge is automatically marked <span className="badge-pill">Issued</span> when handed to a visitor at check-in, and returns to <span className="badge-pill">Available</span> the moment that visitor checks out.</p>
            <ol>
              <li>On the <strong>Settings</strong> page, scroll down to <strong>Badge Inventory</strong>.</li>
              <li>Use the dropdown to select the plant you're adding badges for.</li>
              <li>Type a badge number (e.g. <code>1</code>, <code>2</code>, or however your physical badges are numbered) and click <strong>Add</strong> — or just press Enter to add them one after another quickly.</li>
              <li>Repeat until every physical badge for that plant is listed. Switch the dropdown to add badges for the next plant.</li>
            </ol>
            <div className="callout warn"><strong>Tip:</strong> If a Kiosk shows "no badges available" during check-in, it means this plant's pool is exhausted (all issued right now) or empty — add more here.</div>
            <figure>
              <img src="/playbook-assets/shot-badges.jpg" alt="Badge Inventory section" />
              <figcaption>Badge Inventory — badges are added per plant and automatically cycle between Available and Issued.</figcaption>
            </figure>
          </div>
        </section>

        <section className="step" id="step4">
          <div className="step-title"><span className="step-number">4</span><h2>Get Employees / Hosts Onboarded</h2></div>
          <p className="step-sub">No manual account creation needed for staff — they self sign-up</p>
          <div className="step-body">
            <p>Any employee with a company (<code>@rampgroup.co.in</code>) mailbox can join themselves — you don't need to create their account manually:</p>
            <ol>
              <li>Send them the app URL and tell them to click <strong>"Sign in with Microsoft"</strong> on the Sign In screen.</li>
              <li>They log in with their normal Office 365 work account. Their account is created automatically on first sign-in (role: Employee) — this also connects their mailbox so invite emails and Outlook calendar blocking work from their own account.</li>
              <li>On their very first login, they'll see a one-time <strong>"Select Your Plant"</strong> screen — they pick the plant they're based at. This becomes their default plant for every visitor invite they send. They can change it anytime from a "Change" link on their Pre-Register page.</li>
            </ol>
            <div className="two-col">
              <figure>
                <img src="/playbook-assets/shot-preregister.jpg" alt="Employee Pre-Register page with plant banner" />
                <figcaption>Employee's Pre-Register page — shows their current plant with a Change option.</figcaption>
              </figure>
              <figure>
                <img src="/playbook-assets/shot-users.jpg" alt="Admin Users page" />
                <figcaption>Admin → Users — manage roles, assign/override a plant, and grant "Any plant" access.</figcaption>
              </figure>
            </div>
            <p><strong>Managing staff from the Admin side</strong> (sidebar → <strong>Users</strong>):</p>
            <ul>
              <li><strong>Change someone's role</strong> using the role dropdown (Employee / Security / Admin).</li>
              <li><strong>Reassign a plant</strong> for anyone using the plant dropdown next to their name.</li>
              <li><strong>Grant "Any plant" access</strong> (checkbox, Employees only) for staff who travel between sites — they'll then get an extra dropdown on their invite form to pick a different plant per visitor, instead of being locked to one.</li>
              <li><strong>Create a Security / Gate account</strong> manually here via <strong>+ Add User</strong> (role: Security) — these are shared logins for the gate tablets and use a password you set, since gate staff don't have a Microsoft SSO login for the kiosk. Optionally assign that Security account a plant too — this locks their Kiosk's Gate field to that plant automatically (see Step 5).</li>
            </ul>
          </div>
        </section>

        <section className="step" id="step5">
          <div className="step-title"><span className="step-number">5</span><h2>Set Up a Gate Kiosk Device</h2></div>
          <p className="step-sub">Turn a tablet/PC at the gate into a locked check-in station</p>
          <div className="step-body">
            <ol>
              <li><strong>Create a Security account</strong> for that gate/plant from Users → Add User (see Step 4). Assign it that plant if you want the gate field pre-locked.</li>
              <li><strong>Open the app URL</strong> on the tablet in Chrome (Android/Windows) or Safari (iPad), and sign in with that Security account.</li>
              <li><strong>Install it as an app</strong> so it opens full-screen with no browser bars:
                <ul>
                  <li><em>Android Chrome:</em> tap the ⋮ menu → "Add to Home screen" / "Install app".</li>
                  <li><em>iPad Safari:</em> tap the Share icon → "Add to Home Screen".</li>
                  <li><em>Windows Chrome/Edge:</em> click the install icon (⊕) in the address bar.</li>
                </ul>
              </li>
              <li>Launch the app from the new home-screen icon — it opens in full-screen "Gate Mode" showing Check In / Check Out.</li>
            </ol>
            <div className="callout">
              <strong>Locking the device to only this app (true kiosk mode):</strong> this last step happens at the device/OS level, not inside the app, since every OS handles it differently:
              <ul>
                <li><strong>Android:</strong> use built-in <em>Screen Pinning</em> (Settings → Security), or a free kiosk-launcher app like "Fully Kiosk Browser" pointed at the app URL for a fully locked-down tablet.</li>
                <li><strong>iPad:</strong> Settings → Accessibility → <em>Guided Access</em> → turn on, then triple-click the side/top button while the app is open to lock it.</li>
                <li><strong>Windows:</strong> Settings → Accounts → Family &amp; other users → Set up a kiosk (Assigned Access), pointing it at the installed app/browser.</li>
              </ul>
            </div>
            <figure>
              <img src="/playbook-assets/shot-kioskhome.jpg" alt="Kiosk Gate Mode home screen" />
              <figcaption>Kiosk "Gate Mode" home screen — the only two actions a gate device needs.</figcaption>
            </figure>
          </div>
        </section>

        <section className="step" id="step6">
          <div className="step-title"><span className="step-number">6</span><h2>Pre-Register vs Walk-In</h2></div>
          <p className="step-sub">Two ways a visit gets started</p>
          <div className="step-body">
            <p>When Security taps <strong>Check In Visitor</strong> on the Kiosk, they're asked how the visitor is arriving:</p>
            <ul>
              <li><strong>Pre-Registered</strong> — used when an Employee already sent an invite ahead of time (via their Pre-Register page). Security searches the visitor's name or phone, taps their entry, and most details (host, purpose, plant) are already filled in — just confirm and continue.</li>
              <li><strong>Walk-In</strong> — used for unannounced visitors with no invite. Security fills in the visitor's details, host, purpose, and plant from scratch on the spot.</li>
            </ul>
            <p>Both paths then continue through the same steps: Photo/ID capture → Safety &amp; CTPAT briefing e-signatures → badge assignment → check-in complete.</p>
            <figure>
              <img src="/playbook-assets/shot-choice.jpg" alt="Pre-Registered vs Walk-In choice screen" />
              <figcaption>The first screen of every check-in — choose based on whether the visitor was invited ahead of time.</figcaption>
            </figure>
          </div>
        </section>

        <section className="step" id="step7">
          <div className="step-title"><span className="step-number">7</span><h2>Checking Visitors Out</h2></div>
          <p className="step-sub">Return their badge and close out the visit</p>
          <div className="step-body">
            <ol>
              <li>On the Kiosk home screen, tap <strong>Check Out Visitor</strong>.</li>
              <li>Search by the visitor's name, phone number, or the badge number printed on their card.</li>
              <li>Tap <strong>Check Out</strong> next to their entry — this records their exit time and instantly returns their badge to the Available pool for that plant.</li>
            </ol>
            <figure>
              <img src="/playbook-assets/shot-checkout.jpg" alt="Check Out search screen" />
              <figcaption>Check Out screen — search by name, phone, or badge number.</figcaption>
            </figure>
          </div>
        </section>

        <div style={{ textAlign: "center" }}>
          <a className="backtotop" href="#top">Back to top ↑</a>
        </div>
      </div>

      <footer>
        Factory Visitor Hub — Radish Technologies · Internal Admin &amp; HR Reference
      </footer>
    </div>
  );
}
